var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1018_102752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7734 3.48438H18.8828V2H17.3984V3.48438H7.60156V2H6.11719V3.48438H5.22656C3.99884 3.48438 3 4.48321 3 5.71094V18.7734C3 20.0012 3.99884 21 5.22656 21H19.7734C21.0012 21 22 20.0012 22 18.7734V5.71094C22 4.48321 21.0012 3.48438 19.7734 3.48438ZM20.5156 18.7734C20.5156 19.1827 20.1827 19.5156 19.7734 19.5156H5.22656C4.81732 19.5156 4.48438 19.1827 4.48438 18.7734V8.97656H20.5156V18.7734ZM20.5156 7.49219H4.48438V5.71094C4.48438 5.3017 4.81732 4.96875 5.22656 4.96875H6.11719V6.45312H7.60156V4.96875H17.3984V6.45312H18.8828V4.96875H19.7734C20.1827 4.96875 20.5156 5.3017 20.5156 5.71094V7.49219Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82031 10.5352H7.30469V12.0195H5.82031V10.5352ZM8.78906 10.5352H10.2734V12.0195H8.78906V10.5352ZM11.7578 10.5352H13.2422V12.0195H11.7578V10.5352ZM14.7266 10.5352H16.2109V12.0195H14.7266V10.5352ZM17.6953 10.5352H19.1797V12.0195H17.6953V10.5352ZM5.82031 13.5039H7.30469V14.9883H5.82031V13.5039ZM8.78906 13.5039H10.2734V14.9883H8.78906V13.5039ZM11.7578 13.5039H13.2422V14.9883H11.7578V13.5039ZM14.7266 13.5039H16.2109V14.9883H14.7266V13.5039ZM5.82031 16.4727H7.30469V17.957H5.82031V16.4727ZM8.78906 16.4727H10.2734V17.957H8.78906V16.4727ZM11.7578 16.4727H13.2422V17.957H11.7578V16.4727ZM14.7266 16.4727H16.2109V17.957H14.7266V16.4727ZM17.6953 13.5039H19.1797V14.9883H17.6953V13.5039Z",
    fill: "#7D7D7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1018_102752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(3 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/dateIcon.76d7ae01e182cf76faf9bb35dc528b32.svg";
export { ForwardRef as ReactComponent };